import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Facturas emitidas
    emittedPayrolls: {
      tableData: [],
      totalEmittedPayrolls: 0
    },
    queryEmittedPayrolls: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    // Facturas recibidas
    receivedPayrolls: {
      tableData: [],
      totalReceivedPayrolls: 0
    },
    queryReceivedPayrolls: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    // Facturas recibidas
    thirdPayrolls: {
      tableData: [],
      totalThirdPayrolls: 0
    },
    queryThirdPayrolls: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'THIRD',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    invoiceType: true,
    payrollsList: {
      tableData: [],
      totalPayrolls: 0
    }
  }
  return session
}

function initLocal () {
  const local = {
    // Columnas Tabla Facturas
    isShowCompradorFactura: true,
    isShowNumeroFactura: true,
    isShowEmisionFactura: true,
    isShowFechaRegistroFactura: true,
    isShowClaseFactura: false,
    isShowImporteFactura: true,
    isShowEstadoFactura: true,
    isShowEnvioFactura: true,
    isShowCanalFactura: false,
    isShowVendedorFactura: false,
    isShowDivisaFactura: false,
    isShowNumRegistroFactura: false,
    isShowNumSerieFactura: false,
    isShowCentroVendedorFactura: false,
    isShowCentroGenericCompradorFactura: false,
    isShowCentroCompradorFactura: false,
    isShowCentroEntregaCompradorFactura: false,
    isShowCentroFacturadoCompradorFactura: false,
    isShowAnulacionFactura: false,
    isShowServicioFactura: false,
    isShowIdDatabaseFactura: false,
    isShowAccountingDate: false,
    isShowPaymentDate: false,
    isShowPaymentMethod: false,
    isShowSentInEmittedSearch: false,
    isShowTerceroInEmittedSearch: false,
    // Tabla Facturas Recibidas
    isShowCompradorFacturaInReceivedSearch: false,
    isShowNumeroFacturaInReceivedSearch: true,
    isShowEmisionFacturaInReceivedSearch: true,
    isShowFechaRegistroFacturaInReceivedSearch: true,
    isShowClaseFacturaInReceivedSearch: false,
    isShowImporteFacturaInReceivedSearch: true,
    isShowEstadoFacturaInReceivedSearch: true,
    isShowVendedorFacturaInReceivedSearch: true,
    isShowDivisaFacturaInReceivedSearch: false,
    isShowCentroVendedorFacturaInReceivedSearch: false,
    isShowCentroGenericCompradorFacturaInReceivedSearch: false,
    isShowCentroCompradorFacturaInReceivedSearch: false,
    isShowCentroEntregaCompradorFacturaInReceivedSearch: false,
    isShowCentroFacturadoCompradorFacturaInReceivedSearch: false,    
    isShowServicioFacturaInReceivedSearch: false,
    isShowReceptionMethodInReceivedSearch: true,
    isShowNumRegistroFacturaInReceivedSearch: true,
    isShowNumSerieFacturaInReceivedSearch: true,
    isShowIdDatabaseFacturaInReceivedSearch: false,
    isShowAccountingDateInReceivedSearch: false,
    isShowPaymentDateInReceivedSearch: false,
    isShowPaymentMethodInReceivedSearch: false,
    isShowClientInvoiceNumberInReceivedSearch: false,
    isShowSentInReceivedSearch: false,
    // Tabla facturas terceros
    isShowCompradorFacturaInThirdSearch: false,
    isShowTerceroFacturaInThirdSearch: false,
    isShowNumeroFacturaInThirdSearch: true,
    isShowEmisionFacturaInThirdSearch: true,
    isShowFechaRegistroFacturaInThirdSearch: true,
    isShowClaseFacturaInThirdSearch: true,
    isShowImporteFacturaInThirdSearch: true,
    isShowEstadoFacturaInThirdSearch: true,
    isShowVendedorFacturaInThirdSearch: true,
    isShowDivisaFacturaInThirdSearch: false,
    isShowCentroVendedorFacturaInThirdSearch: false,
    isShowCentroGenericCompradorFacturaInThirdSearch: false,
    isShowCentroCompradorFacturaInThirdSearch: false,
    isShowCentroEntregaCompradorFacturaInThirdSearch: false,
    isShowCentroFacturadoCompradorFacturaInThirdSearch: false,    
    isShowServicioFacturaInThirdSearch: false,
    isShowNumRegistroFacturaInThirdSearch: true,
    isShowIdDatabaseFacturaInThirdSearch: false,
    isShowAccountingDateInThirdSearch: false,
    isShowPaymentDateInThirdSearch: false,
    isShowPaymentMethodInThirdSearch: false,
    isShowSentInThirdSearch: false
  }
  return local
}

function setByUserLocalInvoice () {
  const local = {
    // Columnas Tabla Facturas
    isShowCompradorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCompradorFactura,
    isShowNumeroFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumeroFactura,
    isShowEmisionFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEmisionFactura,
    isShowFechaRegistroFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowFechaRegistroFactura,
    isShowClaseFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowClaseFactura,
    isShowImporteFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowImporteFactura,
    isShowEstadoFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEstadoFactura,
    isShowEnvioFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEnvioFactura,
    isShowCanalFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCanalFactura,
    isShowVendedorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowVendedorFactura,
    isShowDivisaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowDivisaFactura,
    isShowNumRegistroFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumRegistroFactura,
    isShowNumSerieFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumSerieFactura,
    isShowCentroVendedorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroVendedorFactura,
    isShowCentroGenericCompradorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroGenericCompradorFactura,
    isShowCentroCompradorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroCompradorFactura,
    isShowCentroEntregaCompradorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroEntregaCompradorFactura,
    isShowCentroFacturadoCompradorFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroFacturadoCompradorFactura,    
    isShowAnulacionFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowAnulacionFactura,
    isShowServicioFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowServicioFactura,
    isShowIdDatabaseFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowIdDatabaseFactura,
    isShowAccountingDate: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowAccountingDate,
    isShowPaymentDate: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentDate,
    isShowPaymentMethod: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentMethod,
    isShowSentInEmittedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowSentInEmittedSearch,    
    isShowTerceroInEmittedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowTerceroInEmittedSearch,
    // Tabla Facturas Recibidas
    isShowCompradorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCompradorFacturaInReceivedSearch,
    isShowNumeroFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumeroFacturaInReceivedSearch,
    isShowEmisionFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEmisionFacturaInReceivedSearch,
    isShowFechaRegistroFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowFechaRegistroFacturaInReceivedSearch,
    isShowClaseFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowClaseFacturaInReceivedSearch,
    isShowImporteFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowImporteFacturaInReceivedSearch,
    isShowEstadoFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEstadoFacturaInReceivedSearch,
    isShowVendedorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowVendedorFacturaInReceivedSearch,
    isShowDivisaFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowDivisaFacturaInReceivedSearch,
    isShowCentroVendedorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroVendedorFacturaInReceivedSearch,
    isShowCentroGenericCompradorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroGenericCompradorFacturaInReceivedSearch,
    isShowCentroCompradorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroCompradorFacturaInReceivedSearch,
    isShowCentroEntregaCompradorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroEntregaCompradorFacturaInReceivedSearch,
    isShowCentroFacturadoCompradorFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroFacturadoCompradorFacturaInReceivedSearch,
    isShowServicioFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowServicioFacturaInReceivedSearch,
    isShowReceptionMethodInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowReceptionMethodInReceivedSearch,
    isShowNumRegistroFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumRegistroFacturaInReceivedSearch,
    isShowNumSerieFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumSerieFacturaInReceivedSearch,
    isShowIdDatabaseFacturaInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowIdDatabaseFacturaInReceivedSearch,
    isShowAccountingDateInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowAccountingDateInReceivedSearch,
    isShowPaymentDateInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentDateInReceivedSearch,
    isShowPaymentMethodInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentMethodInReceivedSearch,
    isShowClientInvoiceNumberInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowClientInvoiceNumberInReceivedSearch,
    isShowSentInReceivedSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowSentInReceivedSearch,
    // Tabla Facturas Terceros
    isShowCompradorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCompradorFacturaInThirdSearch,
    isShowTerceroFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowTerceroFacturaInThirdSearch,
    isShowNumeroFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumeroFacturaInThirdSearch,
    isShowEmisionFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEmisionFacturaInThirdSearch,
    isShowFechaRegistroFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowFechaRegistroFacturaInThirdSearch,
    isShowClaseFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowClaseFacturaInThirdSearch,
    isShowImporteFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowImporteFacturaInThirdSearch,
    isShowEstadoFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowEstadoFacturaInThirdSearch,
    isShowVendedorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowVendedorFacturaInThirdSearch,
    isShowDivisaFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowDivisaFacturaInThirdSearch,
    isShowCentroVendedorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroVendedorFacturaInThirdSearch,
    isShowCentroGenericCompradorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroGenericCompradorFacturaInThirdSearch,
    isShowCentroCompradorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroCompradorFacturaInThirdSearch,
    isShowCentroEntregaCompradorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroEntregaCompradorFacturaInThirdSearch,
    isShowCentroFacturadoCompradorFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowCentroFacturadoCompradorFacturaInThirdSearch,
    isShowServicioFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowServicioFacturaInThirdSearch,
    isShowNumRegistroFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowNumRegistroFacturaInThirdSearch,
    isShowIdDatabaseFacturaInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowIdDatabaseFacturaInThirdSearch,
    isShowAccountingDateInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowAccountingDateInThirdSearch,
    isShowPaymentDateInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentDateInThirdSearch,
    isShowPaymentMethodInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowPaymentMethodInThirdSearch,
    isShowSentInThirdSearch: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).facturas.isShowSentInThirdSearch,
  }
  return local
}

// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Facturas
    isShowCompradorFactura: true,
    isShowNumeroFactura: true,
    isShowEmisionFactura: true,
    isShowFechaRegistroFactura: true,
    isShowClaseFactura: false,
    isShowImporteFactura: true,
    isShowEstadoFactura: true,
    isShowEnvioFactura: true,
    isShowCanalFactura: false,
    isShowVendedorFactura: false,
    isShowDivisaFactura: false,
    isShowNumRegistroFactura: false,
    isShowNumSerieFactura: false,
    isShowCentroVendedorFactura: false,
    isShowCentroGenericCompradorFactura: false,
    isShowCentroCompradorFactura: false,
    isShowCentroEntregaCompradorFactura: false,
    isShowCentroFacturadoCompradorFactura: false,
    isShowAnulacionFactura: false,
    isShowServicioFactura: false,
    isShowIdDatabaseFactura: false,
    isShowAccountingDate: false,
    isShowPaymentDate: false,
    isShowPaymentMethod: false,
    isShowSentInEmittedSearch: false,
    isShowTerceroInEmittedSearch: false,
    // Tabla Facturas Recibidas
    isShowCompradorFacturaInReceivedSearch: false,
    isShowNumeroFacturaInReceivedSearch: true,
    isShowEmisionFacturaInReceivedSearch: true,
    isShowFechaRegistroFacturaInReceivedSearch: true,
    isShowClaseFacturaInReceivedSearch: false,
    isShowImporteFacturaInReceivedSearch: true,
    isShowEstadoFacturaInReceivedSearch: true,
    isShowVendedorFacturaInReceivedSearch: true,
    isShowDivisaFacturaInReceivedSearch: false,
    isShowCentroVendedorFacturaInReceivedSearch: false,
    isShowCentroGenericCompradorFacturaInReceivedSearch: false,
    isShowCentroCompradorFacturaInReceivedSearch: false,
    isShowCentroEntregaCompradorFacturaInReceivedSearch: false,
    isShowCentroFacturadoCompradorFacturaInReceivedSearch: false,
    isShowServicioFacturaInReceivedSearch: false,
    isShowReceptionMethodInReceivedSearch: true,
    isShowNumRegistroFacturaInReceivedSearch: true,
    isShowNumSerieFacturaInReceivedSearch: true,
    isShowIdDatabaseFacturaInReceivedSearch: false,
    isShowAccountingDateInReceivedSearch: false,
    isShowPaymentDateInReceivedSearch: false,
    isShowPaymentMethodInReceivedSearch: false,
    isShowClientInvoiceNumberInReceivedSearch: false,
    isShowSentInReceivedSearch: false,
    // Tabla Facturas Recibidas
    isShowCompradorFacturaInThirdSearch: false,
    isShowTerceroFacturaInThirdSearch: false,
    isShowNumeroFacturaInThirdSearch: true,
    isShowEmisionFacturaInThirdSearch: true,
    isShowFechaRegistroFacturaInThirdSearch: true,
    isShowClaseFacturaInThirdSearch: false,
    isShowImporteFacturaInThirdSearch: true,
    isShowEstadoFacturaInThirdSearch: true,
    isShowVendedorFacturaInThirdSearch: true,
    isShowDivisaFacturaInThirdSearch: false,
    isShowCentroVendedorFacturaInThirdSearch: false,
    isShowCentroGenericCompradorFacturaInThirdSearch: false,
    isShowCentroCompradorFacturaInThirdSearch: false,
    isShowCentroEntregaCompradorFacturaInThirdSearch: false,
    isShowCentroFacturadoCompradorFacturaInThirdSearch: false,
    isShowServicioFacturaInThirdSearch: false,
    isShowNumRegistroFacturaInThirdSearch: true,
    isShowIdDatabaseFacturaInThirdSearch: false,
    isShowAccountingDateInThirdSearch: false,
    isShowPaymentDateInThirdSearch: false,
    isShowPaymentMethodInThirdSearch: false,
    isShowSentInThirdSearch: false
  },
  session: initSession()
}

const getters = {
  // Facturas emitidas
  emittedPayrolls: state => {
    return state.session.emittedPayrolls
  },
  queryEmittedPayrolls: state => {
    return state.session.queryEmittedPayrolls
  },
  isShowCompradorFactura: state => {
    return state.local.isShowCompradorFactura
  },
  isShowNumeroFactura: state => {
    return state.local.isShowNumeroFactura
  },
  isShowEmisionFactura: state => {
    return state.local.isShowEmisionFactura
  },
  isShowFechaRegistroFactura: state => {
    return state.local.isShowFechaRegistroFactura
  },
  isShowClaseFactura: state => {
    return state.local.isShowClaseFactura
  },
  isShowImporteFactura: state => {
    return state.local.isShowImporteFactura
  },
  isShowEstadoFactura: state => {
    return state.local.isShowEstadoFactura
  },
  isShowEnvioFactura: state => {
    return state.local.isShowEnvioFactura
  },
  isShowVendedorFactura: state => {
    return state.local.isShowVendedorFactura
  },
  isShowDivisaFactura: state => {
    return state.local.isShowDivisaFactura
  },
  isShowNumRegistroFactura: state => {
    return state.local.isShowNumRegistroFactura
  },
  isShowNumSerieFactura: state => {
    return state.local.isShowNumSerieFactura
  },
  isShowCentroVendedorFactura: state => {
    return state.local.isShowCentroVendedorFactura
  },
  isShowCentroGenericCompradorFactura: state => {
    return state.local.isShowCentroGenericCompradorFactura
  },
  isShowCentroCompradorFactura: state => {
    return state.local.isShowCentroCompradorFactura
  },
  isShowCentroEntregaCompradorFactura: state => {
    return state.local.isShowCentroEntregaCompradorFactura
  },
  isShowCentroFacturadoCompradorFactura: state => {
    return state.local.isShowCentroFacturadoCompradorFactura
  },      
  isShowAnulacionFactura: state => {
    return state.local.isShowAnulacionFactura
  },
  isShowServicioFactura: state => {
    return state.local.isShowServicioFactura
  },
  isShowCanalFactura: state => {
    return state.local.isShowCanalFactura
  },
  isShowIdDatabaseFactura: state => {
    return state.local.isShowIdDatabaseFactura
  },
  isShowAccountingDate: state => {
    return state.local.isShowAccountingDate
  },
  isShowPaymentDate: state => {
    return state.local.isShowPaymentDate
  },
  isShowPaymentMethod: state => {
    return state.local.isShowPaymentMethod
  },
  isShowSentInEmittedSearch: state => {
    return state.local.isShowSentInEmittedSearch
  },
  isShowTerceroInEmittedSearch: state => {
    return state.local.isShowTerceroInEmittedSearch
  },
  // Facturas recibidas
  receivedPayrolls: state => {
    return state.session.receivedPayrolls
  },
  queryReceivedPayrolls: state => {
    return state.session.queryReceivedPayrolls
  },
  isShowCompradorFacturaInReceivedSearch: state => {
    return state.local.isShowCompradorFacturaInReceivedSearch
  },
  isShowNumeroFacturaInReceivedSearch: state => {
    return state.local.isShowNumeroFacturaInReceivedSearch
  },
  isShowEmisionFacturaInReceivedSearch: state => {
    return state.local.isShowEmisionFacturaInReceivedSearch
  },
  isShowFechaRegistroFacturaInReceivedSearch: state => {
    return state.local.isShowFechaRegistroFacturaInReceivedSearch
  },
  isShowClaseFacturaInReceivedSearch: state => {
    return state.local.isShowClaseFacturaInReceivedSearch
  },
  isShowImporteFacturaInReceivedSearch: state => {
    return state.local.isShowImporteFacturaInReceivedSearch
  },
  isShowEstadoFacturaInReceivedSearch: state => {
    return state.local.isShowEstadoFacturaInReceivedSearch
  },
  isShowVendedorFacturaInReceivedSearch: state => {
    return state.local.isShowVendedorFacturaInReceivedSearch
  },
  isShowDivisaFacturaInReceivedSearch: state => {
    return state.local.isShowDivisaFacturaInReceivedSearch
  },
  isShowCentroVendedorFacturaInReceivedSearch: state => {
    return state.local.isShowCentroVendedorFacturaInReceivedSearch
  },
  isShowCentroGenericCompradorFacturaInReceivedSearch: state => {
    return state.local.isShowCentroGenericCompradorFacturaInReceivedSearch
  },
  isShowCentroCompradorFacturaInReceivedSearch: state => {
    return state.local.isShowCentroCompradorFacturaInReceivedSearch
  },
  isShowCentroEntregaCompradorFacturaInReceivedSearch: state => {
    return state.local.isShowCentroEntregaCompradorFacturaInReceivedSearch
  },
  isShowCentroFacturadoCompradorFacturaInReceivedSearch: state => {
    return state.local.isShowCentroFacturadoCompradorFacturaInReceivedSearch
  },
  isShowServicioFacturaInReceivedSearch: state => {
    return state.local.isShowServicioFacturaInReceivedSearch
  },
  isShowReceptionMethodInReceivedSearch: state => {
    return state.local.isShowReceptionMethodInReceivedSearch
  },
  isShowNumRegistroFacturaInReceivedSearch: state => {
    return state.local.isShowNumRegistroFacturaInReceivedSearch
  },
  isShowNumSerieFacturaInReceivedSearch: state => {
    return state.local.isShowNumSerieFacturaInReceivedSearch
  },
  isShowIdDatabaseFacturaInReceivedSearch: state => {
    return state.local.isShowIdDatabaseFacturaInReceivedSearch
  },
  isShowAccountingDateInReceivedSearch: state => {
    return state.local.isShowAccountingDateInReceivedSearch
  },
  isShowPaymentDateInReceivedSearch: state => {
    return state.local.isShowPaymentDateInReceivedSearch
  },
  isShowPaymentMethodInReceivedSearch: state => {
    return state.local.isShowPaymentMethodInReceivedSearch
  },
  isShowClientInvoiceNumberInReceivedSearch: state => {
    return state.local.isShowClientInvoiceNumberInReceivedSearch
  },
  isShowSentInReceivedSearch: state => {
    return state.local.isShowSentInReceivedSearch
  },
  // Facturas terceros
  thirdPayrolls: state => {
    return state.session.thirdPayrolls
  },
  queryThirdPayrolls: state => {
    return state.session.queryThirdPayrolls
  },
  isShowCompradorFacturaInThirdSearch: state => {
    return state.local.isShowCompradorFacturaInThirdSearch
  },
  isShowTerceroFacturaInThirdSearch: state => {
    return state.local.isShowTerceroFacturaInThirdSearch
  },
  isShowNumeroFacturaInThirdSearch: state => {
    return state.local.isShowNumeroFacturaInThirdSearch
  },
  isShowEmisionFacturaInThirdSearch: state => {
    return state.local.isShowEmisionFacturaInThirdSearch
  },
  isShowFechaRegistroFacturaInThirdSearch: state => {
    return state.local.isShowFechaRegistroFacturaInThirdSearch
  },
  isShowClaseFacturaInThirdSearch: state => {
    return state.local.isShowClaseFacturaInThirdSearch
  },
  isShowImporteFacturaInThirdSearch: state => {
    return state.local.isShowImporteFacturaInThirdSearch
  },
  isShowEstadoFacturaInThirdSearch: state => {
    return state.local.isShowEstadoFacturaInThirdSearch
  },
  isShowVendedorFacturaInThirdSearch: state => {
    return state.local.isShowVendedorFacturaInThirdSearch
  },
  isShowDivisaFacturaInThirdSearch: state => {
    return state.local.isShowDivisaFacturaInThirdSearch
  },
  isShowCentroVendedorFacturaInThirdSearch: state => {
    return state.local.isShowCentroVendedorFacturaInThirdSearch
  },
  isShowCentroGenericCompradorFacturaInThirdSearch: state => {
    return state.local.isShowCentroGenericCompradorFacturaInThirdSearch
  },
  isShowCentroCompradorFacturaInThirdSearch: state => {
    return state.local.isShowCentroCompradorFacturaInThirdSearch
  },
  isShowCentroEntregaCompradorFacturaInThirdSearch: state => {
    return state.local.isShowCentroEntregaCompradorFacturaInThirdSearch
  },
  isShowCentroFacturadoCompradorFacturaInThirdSearch: state => {
    return state.local.isShowCentroFacturadoCompradorFacturaInThirdSearch
  },
  isShowServicioFacturaInThirdSearch: state => {
    return state.local.isShowServicioFacturaInThirdSearch
  },
  isShowNumRegistroFacturaInThirdSearch: state => {
    return state.local.isShowNumRegistroFacturaInThirdSearch
  },
  isShowIdDatabaseFacturaInThirdSearch: state => {
    return state.local.isShowIdDatabaseFacturaInThirdSearch
  },
  isShowAccountingDateInThirdSearch: state => {
    return state.local.isShowAccountingDateInThirdSearch
  },
  isShowPaymentDateInThirdSearch: state => {
    return state.local.isShowPaymentDateInThirdSearch
  },
  isShowPaymentMethodInThirdSearch: state => {
    return state.local.isShowPaymentMethodInThirdSearch
  },
  isShowSentInThirdSearch: state => {
    return state.local.isShowSentInThirdSearch
  },
  payrollsList: state => {
    return state.session.payrollsList
  }
}

const actions = {

  // Crear key Usuario
  setUserNameInvoice ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    if(B2bUserConfigSession.activeUser && B2bUserConfigSession.activeUser.data && B2bUserConfigSession.activeUser.data.username){
      state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
      if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
        state.local = setByUserLocalInvoice()
      }
    }
  },

  async isNewVersionFacturasLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.facturas)
    return isnew
  },
  /**
   * Añade a las facturas de la consulta el cierre contable
   * @param {*} param0
   * @param {*} data
   */
  async addAllInvoices ({
    commit,
    rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
            rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      if (data.query.statusId === '') {
        data.query.statusId = null
      }
      const response = await axios({
        method: 'POST',
        url: '/invoicenote/addAccountingClose',
        data: data.query
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR getPayrolls --- ', error.response)
      throw error.response
    }
  },
  async removeInvoiceSelected ({
    commit,
    rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoicenote/removeAccountingClose',
        data: data
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR getPayrolls --- ', error.response)
      throw error.response
    }
  },
  /**
   * Añade a la lista de facturas el cierre contable
   * @param {*} param0
   * @param {*} data
   */
  async addInvoicesSelected ({
    commit,
    rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoicenote/addAccountingCloseToList',
        data: data
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR getPayrolls --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer las Facturas.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getPayrolls ({
    commit,
    rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
                rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/invoicenote',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      if (data.query.searchType === 'EMITTED') {
        commit('EMITTED_PAYROLLS_STATE', {
          tableData: response.data.content,
          totalEmittedPayrolls: response.data.totalElements
        })
      } else if (data.query.searchType === 'THIRD') {
        commit('THIRD_PAYROLLS_STATE', {
          tableData: response.data.content,
          totalThirdPayrolls: response.data.totalElements
        })
      } else {
        commit('RECEIVED_PAYROLLS_STATE', {
          tableData: response.data.content,
          totalReceivedPayrolls: response.data.totalElements
        })
      }
      // JHB FIN Eliminar lo que está entre las etiquetas JHB
      commit('PAYROLLS_STATE', {
        tableData: response.data.content,
        totalPayrolls: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR getPayrolls --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los eventos
   *  @param {*} invoiceId
   */
   async getEventsBpm ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceId + '/eventbpm',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        }
      })

      console.log('RESPONSE getEvents:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getResendEmailsInvoiceNote ({
    commit,
    rootState
  }, params) {
    try {
      console.log('params',params)
      console.log('typeof', typeof params.invoiceNoteId)
      const response = await axios({
        method: 'GET',
        url: 'invoicenote/resendEmails',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          invoiceNoteId: params.invoiceNoteId,
          idCommunicationMethod: params.communicationMethodId,
          isDefault: params.isDefault,
          searchType: params.searchType 
        },
        data: {
          idCommunicationMethod: params.communicationMethodId,
          isDefault: params.isDefault,
          searchType: params.searchType
        }
      })
 
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para Exportar Todas las Facturas a CSV
     */
  async handleDownloadAllCsv ({
    commit,
    rootState
  }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
                rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/csv',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params,
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'all-css-audits.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      console.log('response.headers ' + JSON.stringify(response.headers))
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para descargar ZIP de todos los PDF de Factuas
     * @param {*} invoiceNoteIds
     *
     */
  async handleDownloadMultiInvoiceNotesPdf ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/pdf',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          invoiceNoteId: params.invoiceNoteId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pdfs-facturas.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para descargar ZIP de todos los Originales Firmados de las Facturas
     * @param {*} invoiceNoteIds
     *
     **/
  async handleDownloadMultiInvoiceSignedOriginal ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/signedoriginal',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params,
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'originales-firmados-facturas.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para reenviar las Facturas
     * @param {*} invoiceNoteIds
     *
     **/
  async handleResendMultipleInvoices ({
    commit,
    rootState
  }, params) {
    try {
      console.log('params:' + JSON.stringify(params))
      console.log('invoiceNoteIds:' + JSON.stringify(params.invoiceNoteId))
      const response = await axios({
        method: 'PUT',
        url: '/invoicenote/multipleforward',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          invoiceNoteId: params.invoiceNoteId,
          searchType: params.searchType
        },
        data: {
          idCommunicationMethod: params.communicationMethodId,
          isDefault: params.isDefault,
          searchType: params.searchType,
          newEmails: params.newEmails
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
 
  /**
     * Servicio para descargar Original Firmado de una Factura
     * @param {*} invoiceNoteId
     */
  async downloadInvoiceFormatted ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/originalformatted',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'factura-original'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para cancelar una Factura
     * @param {*} params
     */
  async cancelInvoiceNote ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/invoicenote/' + params.invoiceNoteId + '/cancellation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          motive: params.motive,
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Acciones para tabla de facturas emitidas
  queryEmittedPayrollsState: ({
    commit
  }, payload) => {
    commit('QUERY_EMITTED_PAYROLLS_STATE', payload)
  },
  isShowCompradorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMPRADOR_FACTURA', payload)
  },
  isShowNumeroFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUMERO_FACTURA', payload)
  },
  isShowEmisionFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_EMISION_FACTURA', payload)
  },
  isShowFechaRegistroFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_REGISTRO_FACTURA', payload)
  },
  isShowClaseFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CLASE_FACTURA', payload)
  },
  isShowImporteFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_IMPORTE_FACTURA', payload)
  },
  isShowEstadoFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ESTADO_FACTURA', payload)
  },
  isShowEnvioFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ENVIO_FACTURA', payload)
  },
  isShowVendedorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VENDEDOR_FACTURA', payload)
  },
  isShowDivisaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DIVISA_FACTURA', payload)
  },
  isShowNumRegistroFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_REGISTRO_FACTURA', payload)
  },
  isShowNumSerieFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_SERIE_FACTURA', payload)
  },
  isShowCentroVendedorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_FACTURA', payload)
  },
  isShowCentroGenericCompradorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_GENERIC_COMPRADOR_FACTURA', payload)
  },
  isShowCentroCompradorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_FACTURA', payload)
  },
  isShowCentroEntregaCompradorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_COMPRADOR_FACTURA', payload)
  },
  isShowCentroFacturadoCompradorFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_FACTURADO_COMPRADOR_FACTURA', payload)
  },      
  isShowAnulacionFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ANULACION_FACTURA', payload)
  },
  isShowAccountingDateAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ACCOUNTING_DATE', payload)
  },
  isShowPaymentDateAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_DATE', payload)
  },
  isShowPaymentMethodAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_METHOD', payload)
  },
  isShowSentInEmittedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SENT_EMITTED', payload)
  },
  isShowServicioFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_FACTURA', payload)
  },
  isShowCanalFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CANAL_FACTURA', payload)
  },
  isShowIdDatabaseFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ID_DATABASE_FACTURA', payload)
  },
  isShowTerceroInEmittedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TERCERO_FACTURA', payload)
  },
  // Acciones para tabla de recibidas
  queryReceivedPayrollsState: ({
    commit
  }, payload) => {
    commit('QUERY_RECEIVED_PAYROLLS_STATE', payload)
  },
  // Tabla Facturas Recibidas
  isShowCompradorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMPRADOR_FACTURA_RECIBIDAS', payload)
  },
  isShowNumeroFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_FACTURA_RECIBIDAS', payload)
  },
  isShowEmisionFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_EMISION_FACTURA_RECIBIDAS', payload)
  },
  isShowFechaRegistroFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_REGISTRO_RECIBIDAS', payload)
  },
  isShowClaseFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CLASE_RECIBIDAS', payload)
  },
  isShowImporteFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_IMPORTE_FACTURA_RECIBIDAS', payload)
  },
  isShowEstadoFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ESTADO_FACTURA_RECIBIDAS', payload)
  },
  isShowVendedorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VENDEDOR_FACTURA_RECIBIDAS', payload)
  },
  isShowDivisaFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DIVISA_FACTURA_RECIBIDAS', payload)
  },
  isShowCentroVendedorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_RECIBIDAS', payload)
  },
  isShowCentroGenericCompradorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_GENERIC_COMPRADOR_RECIBIDAS', payload)
  },
  isShowCentroCompradorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_RECIBIDAS', payload)
  },
  isShowCentroEntregaCompradorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_COMPRADOR_RECIBIDAS', payload)
  },
  isShowCentroFacturadoCompradorFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_FACTURADO_COMPRADOR_RECIBIDAS', payload)
  },      
  isShowServicioFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_FACTURA_RECIBIDAS', payload)
  },
  isShowReceptionMethodInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_METODO_RECEPCION_RECIBIDAS', payload)
  },
  isShowNumRegistroFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_REGISTRO_FACTURA_RECIBIDAS', payload)
  },
  isShowNumSerieFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_SERIE_FACTURA_RECIBIDAS', payload)
  },
  isShowIdDatabaseFacturaInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ID_DATABASE_FACTURA_RECIBIDAS', payload)
  },
  isShowAccountingDateInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ACCOUNTING_DATE_RECIBIDAS', payload)
  },
  isShowPaymentDateInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_DATE_RECIBIDAS', payload)
  },
  isShowPaymentMethodInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_METHOD_RECIBIDAS', payload)
  },
  isShowClientInvoiceNumberInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CLIENT_INVOICE_NUMBER_RECIBIDAS', payload)
  },
  isShowSentInReceivedSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SENT_RECEIVED', payload)
  },
  // Acciones para tabla de terceros
  queryThirdPayrollsState: ({
    commit
  }, payload) => {
    commit('QUERY_THIRD_PAYROLLS_STATE', payload)
  },
  // Tabla Facturas Recibidas
  isShowCompradorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMPRADOR_FACTURA_TERCEROS', payload)
  },
  isShowTerceroFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TERCERO_FACTURA_TERCEROS', payload)
  },
  isShowNumeroFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_FACTURA_TERCEROS', payload)
  },
  isShowEmisionFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_EMISION_FACTURA_TERCEROS', payload)
  },
  isShowFechaRegistroFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_REGISTRO_TERCEROS', payload)
  },
  isShowClaseFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CLASE_TERCEROS', payload)
  },
  isShowImporteFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_IMPORTE_FACTURA_TERCEROS', payload)
  },
  isShowEstadoFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ESTADO_FACTURA_TERCEROS', payload)
  },
  isShowVendedorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VENDEDOR_FACTURA_TERCEROS', payload)
  },
  isShowDivisaFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DIVISA_FACTURA_TERCEROS', payload)
  },
  isShowCentroVendedorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_TERCEROS', payload)
  },
  isShowCentroGenericCompradorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_GENERIC_COMPRADOR_TERCEROS', payload)
  },
  isShowCentroCompradorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_TERCEROS', payload)
  },
  isShowCentroEntregaCompradorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_COMPRADOR_TERCEROS', payload)
  },
  isShowCentroFacturadoCompradorFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_FACTURADO_COMPRADOR_TERCEROS', payload)
  },      
  isShowServicioFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_FACTURA_TERCEROS', payload)
  },
  isShowNumRegistroFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUM_REGISTRO_FACTURA_TERCEROS', payload)
  },
  isShowIdDatabaseFacturaInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ID_DATABASE_FACTURA_TERCEROS', payload)
  },
  isShowAccountingDateInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ACCOUNTING_DATE_TERCEROS', payload)
  },
  isShowPaymentDateInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_DATE_TERCEROS', payload)
  },
  isShowPaymentMethodInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PAYMENT_METHOD_TERCEROS', payload)
  },
  isShowSentInThirdSearchAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SENT_TERCEROS', payload)
  },


  // Acciones comunes para emitidas/recibidas
  selectInvoiceNote ({
    commit,
    state
  }, invoice) {
    return new Promise((resolve, reject) => {
      commit('SELECTED_INVOICE', invoice)
      resolve()
    })
  },

  // Acciones para pagina de detalle de facturas
  async checkStatusInvoice ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/statusonline',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async searchStatusInvoice ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/searchstatusonline',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer detalle de una Factura
     * @param {*} invoiceNoteId
     */
  async getInvoiceNote ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'invoicenote/' + params.invoiceNoteId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getInvoiceNoteByLink ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'invoicenote/getbylink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          link: params.link
        },
      })
      const user = {
        data: response.data,
        authToken: response.headers.authorization,
        isActive: true
      }
      const jwt = response.headers.authorization
      axios.defaults.headers.common.Authorization = jwt
      commit('ACTIVE_USER_STATE', user)
      commit('JWT_STATE', jwt)
      
      if (user.data.projects && user.data.projects.length === 1 && user.data.projects[0].personalization) {

        let clientp = ''
        let clients = ''
        let clientbg = ''
        let logo = ''
        // Obtener personalización del proyecto del usuario
        if(user.data.projects[0].personalization.primaryColor && user.data.projects[0].personalization.secondaryColor){
          clientp = user.data.projects[0].personalization.primaryColor
          clients = user.data.projects[0].personalization.secondaryColor
          logo = user.data.projects[0].personalization.logo
        } else {
          // Colores por defecto
          clientp = '#2E6C99'
          clients = '#1376bd'
        }

        // Color fondo: color primario con transparencia
        const colorHSL = HEXtoHSL(clientp)
        clientbg = HSLToHex(colorHSL.h, colorHSL.s-5, 97)

        commit('PRIMARY_COLOR_STATE', clientp)
        commit('SECONDARY_COLOR_STATE', clients)
        commit('CLIENTBG_COLOR_STATE', clientbg)
        commit('LOAD_LOGO', logo)        
        
      }
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getInvoiceNoteByTokenLink ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'invoicenote/getinvoicebytokenlink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL, // 'http://localhost:8084/edocs-rest/rest-api/v1',
        headers: {
          Authorization: 'Bearer ' + params.token
        },
        params: {
          token: params.token || null,
          invoiceId: params.invoiceId || null,
          sellerNif: params.sellerNif || null,
          buyerNif: params.buyerNif || null,
          issueDate: params.issueDate || null,
          invoiceNumber: params.invoiceNumber || null
        },
      })
      const user = {
        data: response.data.myUserInfoTO,
        authToken: response.headers.authorization,
        isActive: true
      }

      const jwt = response.headers.authorization
      axios.defaults.headers.common.Authorization = jwt
      commit('JWT_STATE', jwt)
      commit('ACTIVE_USER_STATE', user)
      commit('URL_IN_STATE', response.data.projectName)
      
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Obtenemos los datos de pago/cobro
   * @param {*} param0 
   * @param {*} invoiceNoteId 
   * @returns 
   */
  async getInvoicePaymentData({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'invoicenote/' + params.invoiceNoteId + '/paymentdata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los documentos relacionados de una factura emitida o recibida
   */
  async getRelatedDocumentsInvoiceNote ({ commit, rootState }, data) {
    try {
      console.log('GET INVOICE RELATED DOCUMENTS --- ', data.query)
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoicenote/' + data.query.invoiceId + '/relatedDocuments',
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para modificar los datos de una Factura
     * @param {*} params
     */
  async modifyInvoiceNote ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/invoicenote/' + params.invoiceId,
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          invoiceNumber: params.invoiceNumber,
          observations: params.observations,
          internalObservations: params.internalObservations,
          pendingTask: params.pendingTask,
          rejectionCategoryId: params.category,
          statusId: params.statusId,
          internalStatusId: params.internalStatusId,
          totalExecutableAmount: params.totalExecutableAmount,
          registerNumber: params.registerNumber,
          sentFlagState: params.sentFlagState,
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para modificar el estados de varias facturas
     * @param {*} params
     */
  async modifyMultipleStatus ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/invoicenote/multiplestatus',
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          invoiceNoteId: params.invoiceNoteId
        },
        data: {
          observations: params.observations,
          statusId: params.statusId,
          searchType: params.searchType
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para visualizar una factura con xsl
     * @param {*} params
     */
  async visualizeWithXsl ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/documentFormat/' + params.documentFormat,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para descargar de los metadatos de una Factura
     * @param {*} invoiceNoteId
     */
  async generateMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/createmetadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob',
        params: {
          searchType: params.searchType
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'metadatos'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar de los metadatos de una Factura
     * @param {*} invoiceNoteId
     */
  async downloadMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/metadata',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'metadatos'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // ADJUNTOS
  async getInvoiceNoteAttachments ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/attachment',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para añadir adjuntos a una Factura
     * @param {*} params
     */
  async addInvoiceNoteAttachment ({
    commit,
    rootState
  }, params) {
    const formData = new FormData()
    formData.append('attachment', params.attachment.raw)
    formData.append('hidden', params.hidden)
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoicenote/' + params.invoiceNoteId + '/attachment',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: formData
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para descargar los adjuntos a la Factura
     * @param {*} params
     */
  async downloadInvoiceNoteAttachment ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/attachment/' + params.attachmentId,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'adjunto-factura'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para eliminar adjunto de la Factura
     * @param {*} params
     */
  async removeInvoiceNoteAttachment ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/invoicenote/' + params.invoiceNoteId + '/attachment/' + params.attachmentId,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer los eventos de una Factura
     * @param {*} invoiceNoteId
     */
  async getInvoiceNoteEvents ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/event',
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select  Métodos Envio por proyecto ,dependiendo de si es emisor y receptor
     * /protocol
     */
  async getOptionsProjectCommunicationsMethods ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/protocol',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para redigitalizar Facturas
     * @param {*} params
     */
  async sendRedigitalization ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/redigitalization/send',
        data: params
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para subir una Factura
     * @param {*} params
     */
  async handleUploadInvoiceNote ({
    commit,
    rootState
  }, params) {
    const formData = new FormData()
    formData.append('invoice', params.invoice.raw)
    formData.append('projectId', params.projectId)
    formData.append('format', params.format)
    if (params.communicationMethodId !== null) formData.append('communicationMethodId', params.communicationMethodId)
    for (let i = 0; i < params.attachments.length; i++) {
      formData.append('attachments[]', params.attachments[i].raw)
    }

    try {
      const response = await axios({
        method: 'POST',
        url: '/upload',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer la notas internas de una Factura
     * @param {*} invoiceNoteId
     */
  async getInvoiceNoteInternalNotes ({
    commit,
    state
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoicenote/' + params.invoiceNoteId + '/internalnote',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para modificar las notas internas de una Factura
     * @param {*} params
     */
  async modifyInvoiceNoteInternalNotes ({
    commit,
    state
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/invoicenote/' + params.invoiceNoteId + '/internalnote',
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          internalNotes: params.internalNotes,
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  invoiceTypeAction: ({
    commit
  }, payload) => {
    commit('INVOICE_TYPE', payload)
  }
}

// mutations
const mutations = {
  resetSessionFacturas (state) {
    state.session = initSession()
    state.local = initLocal()
  },

  // user = JSON.parse(sessionStorage.getItem('activeUser')),

  // Datos Facturas Emitidas
  emittedPayrollsDatesSuperAdmin (state) {
    state.session.queryEmittedPayrolls.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // TODO JHB INICIO Esta mutation se mantiene mientras se prueba nuevo desarrollo
  'EMITTED_PAYROLLS_STATE' (state, payload) {
    state.session.emittedPayrolls = payload
  },
  'QUERY_EMITTED_PAYROLLS_STATE' (state, payload) {
    state.session.queryEmittedPayrolls = payload
  },

  // Columnas Emitidas
  'IS_SHOW_COMPRADOR_FACTURA' (state, payload) {
    state.local.isShowCompradorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCompradorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUMERO_FACTURA' (state, payload) {
    state.local.isShowNumeroFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumeroFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_REGISTRO_FACTURA' (state, payload) {
    state.local.isShowFechaRegistroFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowFechaRegistroFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CLASE_FACTURA' (state, payload) {
    state.local.isShowClaseFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowClaseFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },  
  'IS_SHOW_IMPORTE_FACTURA' (state, payload) {
    state.local.isShowImporteFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowImporteFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ESTADO_FACTURA' (state, payload) {
    state.local.isShowEstadoFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEstadoFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENVIO_FACTURA' (state, payload) {
    state.local.isShowEnvioFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEnvioFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VENDEDOR_FACTURA' (state, payload) {
    state.local.isShowVendedorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowVendedorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DIVISA_FACTURA' (state, payload) {
    state.local.isShowDivisaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowDivisaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_REGISTRO_FACTURA' (state, payload) {
    state.local.isShowNumRegistroFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumRegistroFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_SERIE_FACTURA' (state, payload) {
    state.local.isShowNumSerieFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumSerieFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_FACTURA' (state, payload) {
    state.local.isShowCentroVendedorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroVendedorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMISION_FACTURA' (state, payload) {
    state.local.isShowEmisionFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEmisionFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_GENERIC_COMPRADOR_FACTURA' (state, payload) {
    state.local.isShowCentroGenericCompradorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroGenericCompradorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_FACTURA' (state, payload) {
    state.local.isShowCentroCompradorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroCompradorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_COMPRADOR_FACTURA' (state, payload) {
    state.local.isShowCentroEntregaCompradorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroEntregaCompradorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_FACTURADO_COMPRADOR_FACTURA' (state, payload) {
    state.local.isShowCentroFacturadoCompradorFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroFacturadoCompradorFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },      
  'IS_SHOW_ANULACION_FACTURA' (state, payload) {
    state.local.isShowAnulacionFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowAnulacionFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENT_EMITTED' (state, payload) {
    state.local.isShowSentInEmittedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowSentInEmittedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICIO_FACTURA' (state, payload) {
    state.local.isShowServicioFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowServicioFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CANAL_FACTURA' (state, payload) {
    state.local.isShowCanalFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCanalFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ID_DATABASE_FACTURA' (state, payload) {
    state.local.isShowIdDatabaseFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowIdDatabaseFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACCOUNTING_DATE' (state, payload) {
    state.local.isShowAccountingDate = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowAccountingDate = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_DATE' (state, payload) {
    state.local.isShowPaymentDate = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentDate = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_METHOD' (state, payload) {
    state.local.isShowPaymentMethod = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentMethod = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TERCERO_FACTURA' (state, payload) {
    state.local.isShowTerceroInEmittedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowTerceroInEmittedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Datos Facturas Recibidas
  receivedPayrollsDatesSuperAdmin (state) {
    state.session.queryReceivedPayrolls.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // TODO JHB INICIO Esta mutation se mantiene mientras se prueba nuevo desarrollo
  'RECEIVED_PAYROLLS_STATE' (state, payload) {
    state.session.receivedPayrolls = payload
  },
  'QUERY_RECEIVED_PAYROLLS_STATE' (state, payload) {
    state.session.queryReceivedPayrolls = payload
  },
  // Columnas recibidas
  'IS_SHOW_COMPRADOR_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowCompradorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCompradorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowNumeroFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumeroFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMISION_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowEmisionFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEmisionFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_REGISTRO_RECIBIDAS' (state, payload) {
    state.local.isShowFechaRegistroFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowFechaRegistroFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CLASE_RECIBIDAS' (state, payload) {
    state.local.isShowClaseFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowClaseFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }, 
  'IS_SHOW_IMPORTE_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowImporteFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowImporteFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ESTADO_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowEstadoFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEstadoFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VENDEDOR_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowVendedorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowVendedorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DIVISA_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowDivisaFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowDivisaFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_RECIBIDAS' (state, payload) {
    state.local.isShowCentroVendedorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroVendedorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_GENERIC_COMPRADOR_RECIBIDAS' (state, payload) {
    state.local.isShowCentroGenericCompradorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroGenericCompradorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_RECIBIDAS' (state, payload) {
    state.local.isShowCentroCompradorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroCompradorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_COMPRADOR_RECIBIDAS' (state, payload) {
    state.local.isShowCentroEntregaCompradorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroEntregaCompradorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_FACTURADO_COMPRADOR_RECIBIDAS' (state, payload) {
    state.local.isShowCentroFacturadoCompradorFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroFacturadoCompradorFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },      
  'IS_SHOW_SERVICIO_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowServicioFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowServicioFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_METODO_RECEPCION_RECIBIDAS' (state, payload) {
    state.local.isShowReceptionMethodInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowReceptionMethodInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_REGISTRO_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowNumRegistroFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumRegistroFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_SERIE_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowNumSerieFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumSerieFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ID_DATABASE_FACTURA_RECIBIDAS' (state, payload) {
    state.local.isShowIdDatabaseFacturaInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowIdDatabaseFacturaInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACCOUNTING_DATE_RECIBIDAS' (state, payload) {
    state.local.isShowAccountingDateInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowAccountingDateInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_DATE_RECIBIDAS' (state, payload) {
    state.local.isShowPaymentDateInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentDateInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_METHOD_RECIBIDAS' (state, payload) {
    state.local.isShowPaymentMethodInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentMethodInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CLIENT_INVOICE_NUMBER_RECIBIDAS' (state, payload) {
    state.local.isShowClientInvoiceNumberInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowClientInvoiceNumberInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENT_RECEIVED' (state, payload) {
    state.local.isShowSentInReceivedSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowSentInReceivedSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Datos Facturas Terceros
  thirdPayrollsDatesSuperAdmin (state) {
    state.session.queryThirdPayrolls.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // TODO JHB INICIO Esta mutation se mantiene mientras se prueba nuevo desarrollo
  'THIRD_PAYROLLS_STATE' (state, payload) {
    state.session.thirdPayrolls = payload
  },
  'QUERY_THIRD_PAYROLLS_STATE' (state, payload) {
    state.session.queryThirdPayrolls = payload
  },
  // Columnas TERCEROS
  'IS_SHOW_COMPRADOR_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowCompradorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCompradorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TERCERO_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowTerceroFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowTerceroFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowNumeroFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumeroFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMISION_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowEmisionFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEmisionFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_REGISTRO_TERCEROS' (state, payload) {
    state.local.isShowFechaRegistroFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowFechaRegistroFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CLASE_TERCEROS' (state, payload) {
    state.local.isShowClaseFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowClaseFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }, 
  'IS_SHOW_IMPORTE_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowImporteFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowImporteFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ESTADO_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowEstadoFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowEstadoFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VENDEDOR_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowVendedorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowVendedorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DIVISA_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowDivisaFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowDivisaFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_TERCEROS' (state, payload) {
    state.local.isShowCentroVendedorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroVendedorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_GENERIC_COMPRADOR_TERCEROS' (state, payload) {
    state.local.isShowCentroGenericCompradorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroGenericCompradorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_TERCEROS' (state, payload) {
    state.local.isShowCentroCompradorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroCompradorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_COMPRADOR_TERCEROS' (state, payload) {
    state.local.isShowCentroEntregaCompradorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroEntregaCompradorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_FACTURADO_COMPRADOR_TERCEROS' (state, payload) {
    state.local.isShowCentroFacturadoCompradorFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowCentroFacturadoCompradorFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },      
  'IS_SHOW_SERVICIO_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowServicioFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowServicioFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_REGISTRO_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowNumRegistroFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowNumRegistroFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ID_DATABASE_FACTURA_TERCEROS' (state, payload) {
    state.local.isShowIdDatabaseFacturaInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowIdDatabaseFacturaInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACCOUNTING_DATE_TERCEROS' (state, payload) {
    state.local.isShowAccountingDateInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowAccountingDateInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_DATE_TERCEROS' (state, payload) {
    state.local.isShowPaymentDateInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentDateInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PAYMENT_METHOD_TERCEROS' (state, payload) {
    state.local.isShowPaymentMethodInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowPaymentMethodInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENT_TERCEROS' (state, payload) {
    state.local.isShowSentInThirdSearch = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.facturas.isShowSentInThirdSearch = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Mutaciones comunes para emitidas/recibidas
  'SELECTED_INVOICE' (state, invoice) {
    state.local.invoice = invoice
  },
  'INVOICE_TYPE' (state, payload) {
    state.session.invoiceType = payload
  },
  'PAYROLLS_STATE' (state, payload) {
    state.session.payrollsList = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
